export default "__VITE_ASSET__ca77d0f8__"